import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { prismicImage } from "src/common/utils/prismic-image";

const CountryOption = (props) => (
  <a
    href={props.route}
    data-hook={`choose-country-${props.locale.toLowerCase()}`}
    className={cx("country-option", {
      "country-option--active": props.isActive,
    })}
    onClick={props.handleOnClick}
  >
    <img
      src={prismicImage(props.image)}
      alt={props.iso}
      className="country-option-image"
    />{" "}
    <span className="country-option-text">{props.name}</span>
  </a>
);

CountryOption.propTypes = {
  isActive: PropTypes.bool,
  handleOnClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  iso: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  route: PropTypes.string.isRequired,
};

export default CountryOption;
